import { ValueOf } from '../../..';

export type ContentTypes = ValueOf<typeof ContentTypes>;
export const ContentTypes = {
  InformationItemList: 'informationitemlists',
  Images: 'images',
  InformationItems: 'informationItems',
  FlySasCard: 'flysasCard',
  FlysasCardLists: 'flysasCardLists',
} as const;

export interface RichTextContent {
  content: RichTextContent[];
  nodeType: string;
  value: string;
}
export interface ContentfulFlysasCard {
  id?: string;
  label?: string;
  title?: string;
  heading?: string;
  description: {
    html: string;
    json: RichTextContent | null;
  };
  image?: {
    alt: string;
    id: string;
    src: { url: string };
  } | null;
  button: string | null;
  href?: string | null;
}

export interface ContentfulInformationItem {
  title?: string;
  heading?: string;
  subheading?: string;
  id: string;
  flysasCards?: ContentfulFlysasCard[] | null[];
  description?: {
    html?: string;
  };
  image?: {
    url: string;
    description: string;
  } | null;
  contentType?: string;
  label?: string;
  href?: string;
}
export interface ContentfulImage {
  id: string;
  alt: string | null;
  src: {
    url: string;
  };
}

export interface ContentfulResponseInterface {
  id: string;
  title: string;
  description?: { html?: string };
  flysasCards?: ContentfulFlysasCard[];
  informationItems: ContentfulInformationItem[];
  text?: string;
}
